import { Component, Prop, h } from "@stencil/core";

@Component({
  tag: "f-flyout-loader",
  styleUrl: "f-flyout-loader.scss",
  shadow: true,
})
export class FlyoutLoader {
  @Prop() label: string;

  render() {
    return (
      <div class="flyout-loader">
        <f-activity-indicator />
        {Boolean(this.label) ? (
          <f-visually-hidden>${this.label}</f-visually-hidden>
        ) : (
          ""
        )}
      </div>
    );
  }
}
